export enum Feature {
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  AUTO_CONTACT_AGENT = 'AUTO_CONTACT_AGENT',
  LANDLORD_SECTION = 'LANDLORD_SECTION',
  TENANT_DEPOSIT_INSURANCE_TILE = 'TENANT_DEPOSIT_INSURANCE_TILE',
  TENANT_NETWORK_WIDGET = 'TENANT_NETWORK_WIDGET',
  TENANT_NETWORK_SHADOW_DOM = 'TENANT_NETWORK_SHADOW_DOM',
  WOMENS_DAY_VOUCHER_MODAL = 'WOMENS_DAY_VOUCHER_MODAL',
  WOHNEN_PLUS_LIGHT = 'WOHNEN_PLUS_LIGHT',
  PRIORITIZE_WOHNEN_PLUS_LIGHT = 'PRIORITIZE_WOHNEN_PLUS_LIGHT',
  BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID = 'BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID',
  BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN = 'BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN',
  BIZ_9816_MIETCHECK_WIDGET = 'BIZ_9816_MIETCHECK_WIDGET',
  BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT = 'BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT',
  HOW_4251_WOHNEN_SECTION = 'HOW_4251_WOHNEN_SECTION',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
